"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils/utils");

var _media = require("../utils/media");

var _constants = require("../constants");

var _context = _interopRequireDefault(require("../Row/context"));

var _styled = _interopRequireDefault(require("./styled"));

var _utils2 = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Element = function Element(_ref) {
  var children = _ref.children,
      component = _ref.component,
      css = _ref.css,
      rest = _objectWithoutProperties(_ref, ["children", "component", "css"]);

  var _useContext = (0, _react.useContext)(_context["default"]),
      ctxTheme = _useContext.coolgrid,
      colCss = _useContext.colCss,
      colComponent = _useContext.colComponent,
      ctx = _objectWithoutProperties(_useContext, ["coolgrid", "colCss", "colComponent"]);

  var breakpoints = (0, _media.sortBreakpoints)(ctx.breakpoints);
  var omitKeywords = ['columns', 'gap', 'gutter'];
  var keywords = [].concat(_toConsumableArray(_constants.COLUMN_RESERVED_KEYS), omitKeywords, _toConsumableArray(breakpoints)); // delete gap, it can be passed only via context from Container or Row

  var props = (0, _utils.omit)(rest, omitKeywords);
  var normalizedTheme = (0, _utils2["default"])({
    breakpoints: breakpoints,
    keywords: keywords,
    props: _objectSpread({}, ctxTheme, {}, (0, _utils.pickThemeProps)(rest, keywords), {
      columns: ctx.columns
    })
  });
  return _react["default"].createElement(_styled["default"], _extends({}, (0, _utils.omit)(props, _constants.COLUMN_RESERVED_KEYS), {
    as: component || colComponent,
    coolgrid: _objectSpread({}, ctx, {}, normalizedTheme, {
      extendCss: (0, _utils.extendCss)(css || colCss)
    })
  }), children);
};

Element.displayName = 'vitus-labs/coolgrid/Col';
var _default = Element;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/Col/component.js
// module id = 238
// module chunks = 0